// 모듈 표 읽기 — basicinfo-service 의 GET /api/basicinfo/common/modules (s_module).
// 경로 규칙은 scope.ts 와 같다: 게이트웨이가 서빙하는 origin 에서만 절대 URL, 로컬은 상대경로로 dev 프록시(/chat-api)를 탄다.
// 이 호출은 /api/basicinfo/** 가 게이트웨이에서 도달 가능하다는 전제(상단바 기수·회사 목록과 같은 경로)에 기댄다.
import { GW_ORIGIN } from 'yukimushi-component-fe';
import { authorizedFetch } from './auth';

const SERVED_BY_GATEWAY = window.location.hostname.indexOf('gennolab.co.jp') >= 0;
const BASE = `${SERVED_BY_GATEWAY ? GW_ORIGIN : ''}/chat-api/api/basicinfo`;

/** 원시 응답을 돌려준다(정규화는 lib/moduleRegistry). 배열이 아니면 — 배포본의 SPA fallback 등 — 실패로 본다 */
export async function fetchModules(signal?: AbortSignal): Promise<unknown[]> {
  const res = await authorizedFetch(`${BASE}/common/modules`, { signal });
  if (!res.ok) throw new Error(`/common/modules ${res.status}`);
  const body = await res.json();
  if (!Array.isArray(body)) throw new Error('모듈 목록 형식이 올바르지 않습니다');
  return body;
}

/** 메뉴 평면 목록 읽기 — GET /api/basicinfo/common/menus?lang= (s_menu, 서버가 권한으로 거른다). 배열이 아니면 실패로 본다 */
export async function fetchMenus(lang: string, signal?: AbortSignal): Promise<unknown[]> {
  const res = await authorizedFetch(`${BASE}/common/menus?lang=${encodeURIComponent(lang)}`, { signal });
  if (!res.ok) throw new Error(`/common/menus ${res.status}`);
  const body = await res.json();
  if (!Array.isArray(body)) throw new Error('메뉴 목록 형식이 올바르지 않습니다');
  return body;
}
